import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter as ServerRouter } from "../../../backend/services/server/src/trpc/router";
import type { AppRouter as AuthRouter } from "../../../backend/services/authentication/src/trpc/router";

export const trpc = createTRPCReact<ServerRouter & AuthRouter>();
